const f = {
  of: "of"
};
export {
  f as default
};
